/**
 * Centralized React Query keys. Keep all keys here so cache invalidation
 * stays consistent across hooks. Keys are tuples (readonly arrays) per the
 * React Query convention.
 */

export const queryKeys = {
  me: () => ['me'] as const,
  myWorkspaces: () => ['me', 'workspaces'] as const,
  workspaceBySlug: (slug: string) => ['workspace', slug] as const,
  workspaceApps: (slug: string) => ['workspace', slug, 'apps'] as const,
  workspaceMembers: (slug: string, page = 1) => ['workspace', slug, 'members', page] as const,
  workspaceInvites: (slug: string) => ['workspace', slug, 'invites'] as const,
  workspaceOnboarding: (slug: string) => ['workspace', slug, 'onboarding'] as const,
  slugCheck: (slug: string) => ['workspace', 'check-slug', slug] as const,
  workspaceResolve: (slug: string) => ['workspace', 'resolve', slug] as const,
  provisioningStatus: (slug: string) => ['workspace', slug, 'provisioning-status'] as const,
  userAppAccess: (slug: string, userId: number) =>
    ['workspace', slug, 'users', userId, 'apps'] as const,
  invitePreview: (token: string) => ['invite', token] as const,
  twoFactorStatus: () => ['auth', '2fa', 'status'] as const,
  oauthRequest: (id: string) => ['oauth', 'request', id] as const,
} as const;
